import React, { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  disabledClassName?: string;
  onClick?: VoidFunction;
}

const Button: FC<Props> = ({
  disabledClassName,
  disabled,
  className,
  ...props
}) => {
  return (
    <button
      className={disabled ? disabledClassName || 'disabled-btn' : className}
      disabled={disabled}
      {...props}
    ></button>
  );
};

export default Button;
